import { Container, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/AuthContext';

export default function LoginLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const { loginStatus } = useAuth();

  if (loginStatus === 'LOGGED_IN') {
    router.push((router.query.redirect as string) || '/');
  }

  return (
    <Container
      centerContent
      minW='100dvw'
      minH='100vh'
      bgImage='/images/hexagon-blue.svg'
    >
      <Flex w='full' h='full' placeContent='center'>
        {children}
      </Flex>
    </Container>
  );
}
